import { LocationNumbersService } from '../../../services'

const deleteCallerID = async function ({ dispatch, state }, config) {
  const { locationId, sid } = config
  try {
    const data = await LocationNumbersService.deleteCallerID(locationId, sid)
    await dispatch('fetchLocationTwilio', locationId)
    await dispatch('fetchCallerIDs', {
      locationId: locationId,
      getPaginatedDataOnly: false,
      payload: {
        limit: state.table?.limit,
        page: state.table?.currentPage,
        query: '',
      },
    })
    return Promise.resolve(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export default deleteCallerID
